import PubSub from "underpub-js";

var FormMinimal = function (options) {

  this.options = {
    $el: false,
    baseClass: 'el-FormMinimal',
  };

  $.extend(true, this.options, options);

};

FormMinimal.prototype.init = function () {
  const self = this;

  self.$formFormie = self.options.$el.find(`.${self.options.baseClass}__form--formie`);
  self.$defaultFormieSubmitButton = self.$formFormie.find('.fui-submit');
  self.$customFormieSubmitButton = self.options.$el.find("[data-custom-formie-submit-button]");

  self.options.$el.find('.fui-i').removeClass('fui-i');

  self.handleSubmitButtonSwap();
};

FormMinimal.prototype.handleSubmitButtonSwap = function () {
  const self = this;

  if (!self.$customFormieSubmitButton.length && !self.$defaultFormieSubmitButton.length)
    return;

  self.$defaultFormieSubmitButton.hide();
  self.$customFormieSubmitButton.show().insertAfter(self.$defaultFormieSubmitButton);

  self.$customFormieSubmitButton.on('click', (e) => {
    e.preventDefault();
    self.$defaultFormieSubmitButton.click();
  });
};

export default FormMinimal;